import React from 'react';

const PageHeader: React.FC<{ title: string; children?: React.ReactNode }> = ({ title, children }) => (
  <div className="page-header">
    <h1>{title}</h1>
    {children}
  </div>
);

export default PageHeader;
